import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import SafeIcon from '../SafeIcon';
import * as FiIcons from 'react-icons/fi';
import SettingsPopup from './SettingsPopup';
import LibraryPopup from './LibraryPopup';
import ProfileMenu from '../auth/ProfileMenu';
import EditProfileModal from '../auth/EditProfileModal';

const { FiPlus, FiHelpCircle, FiSettings, FiEye, FiFile } = FiIcons;

const LeftSidebar = ({
  toggleElementsPanel,
  elementsPanelOpen,
  togglePagesPanel,
  pagesPanelOpen,
  onPreviewClick,
  activeWebsiteName,
  activeWebsiteId,
  user,
  profile,
  onLogout,
  onProfileUpdate,
  isSuperAdmin,
  onOpenDashboard,
}) => {
  const [showSettings, setShowSettings] = useState(false);
  const [showLibrary, setShowLibrary] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false);

  const menuItems = [
    { id: 'pages',    icon: FiFile,     label: 'Pages' },
    { id: 'add',      icon: FiPlus,     label: 'Add Widget' },
    { id: 'preview',  icon: FiEye,      label: 'Preview' },
    { id: 'settings', icon: FiSettings, label: 'Settings' },
  ];

  if (isSuperAdmin) {
    menuItems.push({ id: 'dashboard', icon: FiIcons.FiZap, label: 'Dashboard' });
  }

  const handleClick = (id) => {
    if (id === 'pages')    togglePagesPanel();
    else if (id === 'add') toggleElementsPanel();
    else if (id === 'preview') onPreviewClick?.();
    else if (id === 'settings') setShowSettings(true);
    else if (id === 'dashboard') onOpenDashboard?.();
  };

  const isActive = (id) => {
    if (id === 'pages') return pagesPanelOpen;
    if (id === 'add')   return elementsPanelOpen;
    return false;
  };

  return (
    <>
      <div
        className="w-16 bg-[#0a0a0a] border-r border-[#1e2228] flex flex-col justify-between py-4 shrink-0 shadow-[2px_0_10px_rgba(0,0,0,0.3)]"
        style={{ zIndex: 100 }}
      >
        <div className="flex flex-col items-center space-y-2">
          {user && (
            <div className="mb-2">
              <ProfileMenu
                user={user}
                profile={profile}
                onLogout={onLogout}
                onEditProfile={() => setShowEditProfile(true)}
              />
            </div>
          )}
          {menuItems.map(item => (
            <button
              key={item.id}
              onClick={() => handleClick(item.id)}
              title={item.label}
              className={`p-3 rounded-xl transition-all duration-200 group relative ${
                isActive(item.id)
                  ? 'bg-[#c8f542]/10 text-[#c8f542]'
                  : item.id === 'preview' || item.id === 'dashboard'
                  ? 'text-gray-500 hover:bg-[#c8f542]/10 hover:text-[#c8f542]'
                  : 'text-gray-500 hover:bg-[#1e2228] hover:text-gray-200'
              }`}
            >
              <SafeIcon icon={item.icon} className="w-5 h-5" />
              {isActive(item.id) && item.id === 'pages' && (
                <span className="absolute top-1 right-1 w-1.5 h-1.5 bg-[#c8f542] rounded-full" />
              )}
              <div
                className="absolute left-full ml-2 px-2 py-1 bg-[#1e2228] border border-[#2c313a] text-white text-xs rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible whitespace-nowrap transition-all duration-200"
                style={{ zIndex: 99999 }}
              >
                {item.label}
              </div>
            </button>
          ))}
        </div>

        <div className="flex flex-col items-center">
          <button className="p-3 text-gray-600 hover:bg-[#1e2228] hover:text-red-400 rounded-xl transition-colors group relative">
            <SafeIcon icon={FiHelpCircle} className="w-5 h-5" />
            <div
              className="absolute left-full ml-2 px-2 py-1 bg-[#1e2228] border border-[#2c313a] text-white text-xs rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible whitespace-nowrap"
              style={{ zIndex: 99999 }}
            >
              Help
            </div>
          </button>
        </div>
      </div>

      {showSettings && createPortal(
        <SettingsPopup
          onClose={() => setShowSettings(false)}
          onOpenLibrary={() => { setShowSettings(false); setShowLibrary(true); }}
          activeWebsiteName={activeWebsiteName}
          activeWebsiteId={activeWebsiteId}
          onOpenPreview={onPreviewClick}
        />,
        document.body
      )}
      {showLibrary && createPortal(
        <LibraryPopup onClose={() => setShowLibrary(false)} mode="manage" />,
        document.body
      )}
      {showEditProfile && user && createPortal(
        <EditProfileModal
          user={user}
          profile={profile}
          onClose={() => setShowEditProfile(false)}
          onSave={updated => { onProfileUpdate?.(updated); setShowEditProfile(false); }}
        />,
        document.body
      )}
    </>
  );
};

export default LeftSidebar;